import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Comportement par défaut de toute l'app : chaque changement de page ramène en
// haut. Les zones qui défilent elles-mêmes (ex. le contenu de l'admin) portent
// l'attribut data-scroll-root et sont remontées aussi.
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.querySelectorAll<HTMLElement>('[data-scroll-root]').forEach((el) => {
      el.scrollTop = 0;
    });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
